// extracted by mini-css-extract-plugin
module.exports = {"newArticle":"PostArticle_newArticle__20uVJ"};